export class CookieTranslationConfig {

    useOfCookies?: string;
    cookieSettingsButton?: string;
    cookieSettings?: string;
    cookieSettingsText?: string;
    reasonOdcookies?: string;
    functionOfWebsite?: string;
    fixOfFailures?: string;
    statistics?: string;
    lightweight?: string;
    offers?: string;
    importantForUs?: string;
    cookieCategories?: string;
    neededCookies?: string;
    preferenceCookies?: string;
    statisticCookies?: string;
    marketingCookies?: string;
    rights?: string;
    moreInformation?: string;
    websiteCookies?: string;
    active?: string;
    settingsCookies?:string;
    websiteStatisticCookies?:string;
    websiteMarketingCookies?:string;

    cookieFunctionText?: string;
    cookieConfigText?: string;
    nameOfTheSite?: string;
    landingPageLinkOfTheSite?: string;
    privacyPolicyLink?: string;
    allAccepted?: string;
    settingsAccepted?: string;
    websiteCookiesAccepted?: string;
    dismiss?: string;
    cookieSettingsOption?:string;



}
